// Color palette for AIATUS QSign
export const C = {
  pri: "#3568A8", priDk: "#274F80", priDp: "#1B3A5E", priLt: "#5B8EC4",
  priPl: "#E6EFF8", priGh: "#F2F7FC",
  acc: "#2196F3", wh: "#FFF", off: "#F7F9FC", bg: "#EFF3F7",
  bd: "#DCE3EC", bdLt: "#ECF0F5",
  tx: "#16263D", txS: "#445D78", txM: "#8898AE", txD: "#A8B8CA",
  ok: "#0EA472", warn: "#E8930C", err: "#DC3545",
  purp: "#7C5CFC", org: "#E86A1C", pink: "#D63384",
  sh: "rgba(53,104,168,.07)", shM: "rgba(53,104,168,.12)",
};
